
import { onMounted, ref } from "vue"

declare const grecaptcha: any

export default({
    name: "registerView",
    props: ['baseUrl'],
    setup(props: any) {
        const isBtnCreateUserLoginShown = ref(false)
        const isBtnCreateUserLoginDisabled = ref(false)
        const userName = ref("")
        const password = ref("")
        const isValidateNotRobotShown = ref(true)
        const registrationStatus = ref(localStorage.getItem("registrationStatus"))
        let captchaWidgetId: any = null

        const reloadPage = () => {
            window.location.reload()
        }

        const createUserLogin = () => {
            const captchaResponse = grecaptcha?.getResponse(captchaWidgetId)
            
            if (!captchaResponse || captchaResponse.length === 0) {
                registrationStatus.value = "Please complete the CAPTCHA verification."
                localStorage.setItem("registrationStatus", registrationStatus.value)
                alert(registrationStatus.value)
                return
            }

            if (userName.value == null || userName.value == "" || userName.value.indexOf("@") < 0) {
                registrationStatus.value = "Please Enter a valid user name. Note that only email is accepted as userName."
                localStorage.setItem("registrationStatus", registrationStatus.value)
                alert(registrationStatus.value)
                return
            }

            if (password.value == null || password.value == "") {
                registrationStatus.value = "Please Enter a valid password"
                localStorage.setItem("registrationStatus", registrationStatus.value)
                alert(registrationStatus.value)
                return
            }

            localStorage.setItem("userName", userName.value)
            isBtnCreateUserLoginDisabled.value = true
            
            let requestUrl = props.baseUrl + "Login/CreateUserLoginForGuard"
            let requestContent = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    UserName: userName.value,
                    Password: password.value,
                    CaptchaResponse: captchaResponse
                })
            }

            fetch(requestUrl, requestContent)
                .then(response => response.json())
                .then(res => {
                    if (res.error == "AlreadyExistingUser") {
                        registrationStatus.value = "User name '" + localStorage.getItem('userName') + "' already taken by someone. Please enter some other user-name."
                        localStorage.setItem("registrationStatus", registrationStatus.value)
                        alert(registrationStatus.value)
                        grecaptcha.reset(captchaWidgetId)
                        reloadPage()
                    } else if (res.usrName != null || res.userName != "") {
                        isBtnCreateUserLoginShown.value = false
                        registrationStatus.value = "User account has been created successfully. A validation link has been sent to your email address. Please click that link to activate your account."
                        localStorage.setItem("registrationStatus", registrationStatus.value)
                        alert(registrationStatus.value)
                        reloadPage()
                    }
                })
                .catch(error => {
                    registrationStatus.value = "User account could not be created. Please try again."
                    localStorage.setItem("registrationStatus", registrationStatus.value)
                    alert(registrationStatus.value)
                    grecaptcha.reset(captchaWidgetId)
                    reloadPage()
                })
        }

        onMounted(() => {
            isBtnCreateUserLoginShown.value = false
            isValidateNotRobotShown.value = true
            
            // Load reCAPTCHA
            const script = document.createElement('script')
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onCaptchaLoaded&render=explicit'
            script.async = true
            script.defer = true
            
            ;(window as any).onCaptchaLoaded = () => {
                captchaWidgetId = grecaptcha.render('validateNotRobot', {
                    sitekey: '6LcFK8gsAAAAAABK1MuXqjMJzDSbY9vPw3uSNNn4',
                    callback: () => {
                        isBtnCreateUserLoginShown.value = true
                    }
                })
            }
            
            document.head.appendChild(script)
        })

        return {
            userName,
            password,
            createUserLogin,
            isBtnCreateUserLoginShown,
            isBtnCreateUserLoginDisabled,
            reloadPage,
            isValidateNotRobotShown,
            registrationStatus,
        }
    }
})
